import { render, staticRenderFns } from "./ProfileUnblockUsersForm.vue?vue&type=template&id=254d98e4&scoped=true&"
import script from "./ProfileUnblockUsersForm.vue?vue&type=script&lang=js&"
export * from "./ProfileUnblockUsersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d98e4",
  null
  
)

export default component.exports